/* global BigInt */
// Financial display arithmetic in integer cents, not repeated floating sums.
export function cents(value) {
  const match = String(value).match(/^(-?)(\d+)(?:\.(\d{1,2}))?$/);
  if (!match) throw new Error('Invalid transaction amount');
  return (match[1] ? -1n : 1n) * (BigInt(match[2]) * 100n + BigInt((match[3] || '').padEnd(2, '0')));
}
export function money(value) {
  const magnitude = value < 0n ? -value : value;
  return `${value < 0n ? '-' : ''}$${magnitude / 100n}.${String(magnitude % 100n).padStart(2, '0')}`;
}
export function selectionSummary(rows, accounts, categories) {
  const groups = new Map(); let net = 0n;
  for (const row of rows) {
    const amount = cents(row.amount); net += amount;
    const key = `${row.account_id}:${row.category_id}`;
    const group = groups.get(key) || { key, account: accounts.find(a => a.id === row.account_id)?.name || 'Unknown account',
      category: categories.find(c => c.id === row.category_id)?.name || 'No category', amount: 0n, count: 0 };
    group.amount += amount; group.count += 1; groups.set(key, group);
  }
  return { net, groups: [...groups.values()] };
}
